import React, { Component } from 'react';
import cs from 'classnames';
import {connect} from 'react-redux';
import {push as changeURL} from 'react-router-redux';
import includes from 'lodash/includes';
import isObject from 'lodash/isObject';

import Button from '~/components/common/Button';
import {videoChange, modalClose} from '~/modules/modal/actions';
import mapDispatch from '~/misc/mapDispatch';
import {track} from '~/misc/metrics';
import {verifyEmailAction} from '~/modules/verify/actions';
import {modalChange} from '~/modules/modal/actions';
import * as modes from '~/modules/modal/modes';

import css from './index.css';
import config from './config.js';
import store from '~/store';

const jumpPara = (type) => {
  if (includes(type.toLocaleLowerCase(), 'standard')) {
    return 'standard';
  }
  if (includes(type.toLocaleLowerCase(), 'premium')) {
    return 'premium';
  }
  if (includes(type.toLocaleLowerCase(), 'professional')) {
    return 'professional';
  }
  return '';
};

const jumpToPayment = (props, e) => {
  e.preventDefault();
  const {accountLevel, free} = props.account;
  const type = isObject(props.context) ? props.context.type : props.context;
  const para = jumpPara(type);
  props.dispatch(modalClose(props.uri));
  // 跳去hp判断来源
  let fromSource = '';
  if (props.context.source) {
    fromSource = props.context.source;
  }
  track(fromSource, {eventName: 'upgrade'});
  let urlParam = `from=${encodeURI(fromSource)}&level=${encodeURI(para)}`;
  return parseInt(accountLevel) > parseInt(free)?props.gotoMembershipPlans(urlParam): props.gotoHp(urlParam);
};

const judgeClick = (e, props) => {
  if (props.context.type === 'pop_download_and_send_verify_email') {
    props.dispatch(modalClose(props.uri));
    if (props.context.source === 'show-phone-button') {
      track('unverified popup', {
        result: 'validate',
      });
    }
    return props.verifyEmail();
  }
  return jumpToPayment(props, e);
};

const trackDownload = (source, type) => {
  if (source === 'show-phone-button') {
    return track('unverified popup', {
      result: type,
    });
  }
  return track(source, {
    result: type,
  });
};



const PopupRender = (props) => {
  const type = isObject(props.context) ? props.context.type : props.context;
  const txt = config[type];
  const source = isObject(props.context) ? props.context.source : '';
  if (type === 'pop_upgrade_to_new_standard') {
    return (
      <div className={css.premiumPopwrap}>
        <div>
          <h1 className={css.headerTxt}>
            Daily Limit<br/>
            Reached
          </h1>
          <div className={css.headerImg}/>
        </div>
        <div className={cs(css.container)}>
          {
            txt.body.map((item, index) => {
              if (index === 2) {
                return (<p className={css.line3} key={index}>{item}</p>);
              } else if (index === 3) {
                return (<p className={css.line4} key={index}>{item}</p>);
              }
              return (<p className={css.line} key={index}>{item}</p>);
            })
          }
          <p className={css.line}>Or come back tomorrow for {props.context.times} more free load views.</p>
        </div>
        <div className={css.myFooter}>
          <Button onClick={props.closePop} className={css.waits}>
            {txt.btnTXT[0]}
          </Button>
          <Button onClick={(e) => judgeClick(e, props)} className={css.continue}>
            {txt.btnTXT[1]}
          </Button>
        </div>
        {!props.isLoggedIn &&
          <p className={cs(css.line, css.txtCenter)} >Already a member? Please <span className={cs(css.bl)} onClick={(e) => {e.preventDefault(); props.login()}}>Log in</span> first</p>
        }
      </div>
    );
  }

  return (
    <div className={css.popwrap}>

      <h1 className={css.header}> {txt.header} </h1>

      {txt.body
        ? (<div className={cs(css.container, (type === 'pop_download_and_send_verify_email') && css.txtCenter)}>{
          txt.body.map((item, index) => {
            if (typeof item === typeof []) {
              return (
                <ul className={css.ulPadding} key={index}>
                  {item.map((list, num) => <li className={css.liPadding} key={num}>{list}</li>)}
                </ul>
              );
            }
            return (<div key={index}>{item}</div>);
          })
        }</div>)
        : null
      }

      <div className={css.footer}>
        {type === 'pop_download'
          ? <Button mods={['tall', 'strench']} onClick={props.showVideo}>
            <span className={css.triangle} />
            {txt.btnTXT}
          </Button>
          : <Button mods={['tall', 'strench']} onClick={(e) => judgeClick(e, props)}>
            {txt.btnTXT}
          </Button>
        }
        {type === 'pop_download_and_send_verify_email'
          ? null
          : (
            <div className={css.btnWrap}>
              <a
                className={cs(css.googleBtn, css.mgr)}
                onClick={() => trackDownload(source, 'google')}
                href='https://app.appsflyer.com/com.truckerpath.truckloads?pid=website&c=carriers_page_middle_promo'
              />
              <a
                className={cs(css.appBtn)}
                onClick={() => trackDownload(source, 'app store')}
                href='https://app.appsflyer.com/id1007287939?pid=website&c=carriers_page_middle_promo'
              />
            </div>
          )
        }

      </div>
    </div>
  );
};


class Popup extends Component {
  constructor(props) {
    super(props);
    const { isLoggedIn, login, goBackToUpgrade, context, account, closePopModel } = props;
    if(!isLoggedIn) {
      login({
        nextAction: () => goBackToUpgrade(context)
      });
    }else {
      const upgradeLevel = jumpPara(context.type);
      if (account.accountLevel >= account[upgradeLevel]) {
        closePopModel();
      }
    }

  }

  render() {
    return PopupRender(this.props)
  }
}


export default connect(
  ({ user, account }) => ({
    isLoggedIn: user.isLoggedIn,
    account,
  }),
  mapDispatch({
    showVideo: () => videoChange('', true),
    goToPayment: jumpToPayment,
    closePop: (props, e) => {
      e.preventDefault();
      return modalClose(props.uri);
    },
    closePopModel: props => modalClose(props.uri),
    verifyEmail: () => verifyEmailAction(),
    login: (props, context) => modalChange(modes.LOGIN, context),
    gotoHp: (props, source) => changeURL(`/hp?${source}`),
    gotoMembershipPlans: (_, source) => changeURL(`/membership-plans?${source}`),
    goBackToUpgrade: (props, context) => {
      // check user level
      const account = store.getState().account;
      const upgradeLevel = jumpPara(context.type);
      if (account.accountLevel >= account[upgradeLevel]) return;

      return modalChange('pop', context);
    },
  })
)(Popup);




// WEBPACK FOOTER //
// ./src/components/Popup/index.js